// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","lds-ring":"Loader_lds-ring__ijQAq","loaderOnWrapper":"Loader_loaderOnWrapper__WM+bP","loaderOn":"Loader_loaderOn__5Q68L"};